import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { FaFileAlt, FaEye, FaTrash } from "react-icons/fa";
import VideoBox from "app/shared/components/ReusableComponents/VideoPlayer/container";
import FullViewModal from "app/shared/utility/FullViewModal";

const DocumentList = ({ documentLists, handleDelete, editFlag }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [pdfURL, setPDFURL] = useState("");
  const [showPDFView, setShowPDFView] = useState(false);

  const handleInputClick = (data) => {
    setSelectedData(data);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setSelectedData({});
    setShowModal(false);
  };

  const _showPDF = async (pdfURL) => {
    setShowPDFView(true);
    setPDFURL(pdfURL);
  };
  const _hidePDFPopup = async (pdfURL) => {
    setShowPDFView(false);
    setPDFURL("");
  };

  function ExcelDownload({ fileUrl }) {
    useEffect(() => {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileUrl.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, [fileUrl]);
  
    return <p>Downloading Excel file...</p>;
  }

  return (
    <div className="container">
      {documentLists ? documentLists?.map((doc) => (
        <div
          key={doc.attachmentId}
          className="d-flex align-items-center justify-content-between p-2 my-2 rounded bg-light"
          style={{ border: "1px solid #eee" }}
        >
          {/* File Icon & Name */}
          <div className="d-flex align-items-center">
            <FaFileAlt size={18}  className="text-secondary me-2" />
            <span className="fw-medium fs-6">{doc.documentName}</span>
          </div>

          <div className="d-flex align-items-center">
            <span className="fw-medium fs-6">{doc.documentCategoryName}</span>
          </div>

          {/* Actions (View & Delete) */}
          <div className="d-flex align-items-center">
            <Button variant="light" className="me-2" onClick={() => handleInputClick(doc)}>
              <FaEye size={16} />
            </Button>
            {editFlag == 1 &&
              <Button variant="light" className="text-danger" onClick={() => handleDelete(doc.attachmentId)}>
                <FaTrash size={16} />
              </Button>
            }
          </div>
        </div>
      )) :
          <div className="d-flex align-items-center">
            <span className="fw-medium fs-6">No data available</span>
          </div>
      }
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        dialogclassname={"modal"}
        closebutton
      >
        <div>
          <Modal.Header closeButton style={{ alignItems: "center" }}>
            <Modal.Title style={{ textAlign: "center", flex: "auto" }}>
              {"Preview"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="clide-v2-white-box p-3 m-2" style={{ maxWidth: "35rem" }}>
              {selectedData.documentUrls?.map((doc, index) => {
                const isVideo = doc.type?.startsWith("video/");
                const isDownloadable = [
                  'application/pdf',
                  'application/msword',
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  'application/vnd.ms-excel',
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  'application/vnd.ms-excel.sheet.macroEnabled.12',
                  'application/vnd.ms-excel.template.macroEnabled.12',
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
                  'application/vnd.ms-excel.addin.macroEnabled.12',
                  'text/csv',
                ].includes(doc?.type);

                return (
                  <div key={doc.id || index} className="mb-3">
                    {isVideo ? (
                      <VideoBox url={doc.url} />
                    ) : isDownloadable ? (
                      <a
                        href={doc.url}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                      >
                        📥 Download {doc.fileName}
                      </a>
                    ) : (
                      <img
                        src={doc.previewUrl || doc.url}
                        alt={doc.fileName || "Document"}
                        style={{ maxWidth: "100%", height: "auto" }}
                        className="img-fluid"
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
};

export default DocumentList;
